<template>
  <div>
    <Index
      v-if="show === 'index'"
      :drivers="drivers"
      :meta="meta"
      :query="query"
      :order="order"
      :changeQuery="changeQuery"
      :numberOfBadges="numberOfBadges"
      :updateNumberOfBadges="updateNumberOfBadges"
      :buildParams="buildParams"
      :infoTotalModels="infoTotalModels"
      @find="find()"
      @sendDeleteDriver="sendDeleteDriver"
      @pagination="pagination($event)"
      @createDriver="createDriver"
      @showDriver="showDriver($event)"
    />

    <Show
      v-else @deletedDriver="show = 'index'"
      @toIndex="show = 'index'"
      @sendDeleteDriver="sendDeleteDriver"
      @editDriver="updateDriver"
      :driver="driver"
    />

    <ModalDeleteDriver
      v-model="showModalDeleteDriver"
      title="Excluir motorista"
      :driver="driver"
      @sendDeleteModel="deleteDriver"
    />

    <Modal v-model="showModalFormDriver" width="sm">
      <span slot="header">{{ titleDriverForm }}</span>
      <FormDriver
        v-if="showModalFormDriver"
        :driver="driver"
        @cancel="showModalFormDriver = false"
        @saved="savedDriver($event)"
      />
    </Modal>
  </div>
</template>

<script>
  import Index from '@/components/drivers/container/Index'
  import FormDriver from '@/components/drivers/FormDriver'
  import Show from '@/components/drivers/container/Show'
  import Modal from '../shares/specialTag/Modal'
  import ModalDeleteDriver from '@/components/drivers/ModalDeleteDriver'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'

  export default {
    components: { FormDriver, Index, Modal, ModalDeleteDriver, Show },
    computed: {
      drivers() {
        return this.getModels || []
      }
    },
    created() {
      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data() {
      return {
        nameModel: 'Driver',
        show: 'index',
        showModalDeleteDriver: false,
        showModalFormDriver: false,
        titleDriverForm: '',
        driver: null,
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return this.$options.superMethods.buildParams.call(this, pagination)
      },
      createDriver() {
        this.driver = null
        this.titleDriverForm = 'Cadastrar motorista'
        this.showModalFormDriver = true
      },
      deleteDriver(driver) {
        this.asyncTemplateDelete(driver, {
          after: () => {
            this.showModalDeleteDriver = false
            this.show = 'index'
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      savedDriver(driver) {
        this.find()
        this.showDriver(driver)
      },
      sendDeleteDriver(driver) {
        this.driver = driver
        this.showModalDeleteDriver = true
      },
      showDriver(driver) {
        this.showModalFormDriver = false
        this.driver = driver
        this.show = 'show'
      },
      updateDriver(driver) {
        this.titleDriverForm = 'Editar motorista'
        this.driver = driver
        this.showModalFormDriver = true
      },
    },
    mixins: [GetAccount, ModelMapper],
    name: 'Container',
    superMethods: {
      buildParams: ModelMapper.methods.buildParams
    }
  }
</script>

<style scoped>

</style>
